import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import { Navigate } from 'react-router-dom'
const AccountGovernanceConnections = lazy(() => import('./AccountGovernanceConnections/AccountGovernanceConnections'))
import AccountGovernanceMaps from './AccountGovernanceMaps'
import AccountGovernanceWorkflows from './AccountGovernanceWorkflows'

const AccountGovernance = lazy(() => import('./AccountGovernance'))

export enum GovernanceSectionsRoute {
  Connections = 'connections',
  Maps = 'maps',
  Workflows = 'workflows'
}

const governanceRoutes = [
  {
    path: 'governance',
    element: (
      <LazyLoad>
        <AccountGovernance />
      </LazyLoad>
    ),
    children: [
      {
        path: '',
        element: <Navigate to={GovernanceSectionsRoute.Connections} />
      },
      {
        path: GovernanceSectionsRoute.Connections,
        element: <AccountGovernanceConnections />
      },
      {
        path: GovernanceSectionsRoute.Maps,
        element: <AccountGovernanceMaps />
      },
      {
        path: GovernanceSectionsRoute.Workflows,
        element: <AccountGovernanceWorkflows />
      }
    ]
  }
]

export default governanceRoutes
